/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { IncidentRecordDto } from './incidentRecordDto.schema';

export const CreateIncidentRecord = zod.object({
  "payload": zod.lazy(() => IncidentRecordDto).optional()
});

export type CreateIncidentRecord = zod.input<typeof CreateIncidentRecord>;
export type CreateIncidentRecordOutput = zod.output<typeof CreateIncidentRecord>;
